import { paymentsDeliveryActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  updated: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case paymentsDeliveryActions.PAYMENTS_DELIVERY_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        updated: false
      };
    case paymentsDeliveryActions.PAYMENTS_DELIVERY_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false
      };
    case paymentsDeliveryActions.PAYMENTS_DELIVERY:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        updated: false
      };
    default:
      return state;
  }
};
